export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/face-3-03aaec1f25e7fc3f3cccb933bb4c1de3.jpg";